import axios from 'axios';
// config
// import { HOST_API_KEY } from '../config-global';

// ----------------------------------------------------------------------

// const axiosInstance = axios.create({ baseURL: "https://api.number-one.ae/api" });
const axiosInstance = axios.create({ baseURL: "https://api.number-one.ae/api" });
/**
 * nano /etc/nginx/sites-available/AlRiyada
 * server {
 listen 80;
 server_name number-one.ae www.number-one.ae;

location / {
 root /var/www/AlRiyada/frontend;
 index  index.html index.htm;
 proxy_http_version 1.1;
 proxy_set_header Upgrade $http_upgrade;
 proxy_set_header Connection 'upgrade';
 proxy_set_header Host $host;
 proxy_cache_bypass $http_upgrade;
 try_files $uri $uri/ /index.html;
}
}
 
server {
  listen 80;
  server_name api.number-one.ae;
  location / {
    proxy_pass https://45.90.223.219:8000;
    proxy_http_version 1.1;
    proxy_set_header Upgrade $http_upgrade;
    proxy_set_header Connection 'upgrade';
    proxy_set_header Host $host;
    proxy_cache_bypass $http_upgrade;
    }
}

server {
  listen 80;
  server_name admin.number-one.ae;
  location / {
    root /var/www/AlRiyada/admin;
    index  index.html index.htm;
    proxy_http_version 1.1;
    proxy_set_header Upgrade $http_upgrade;
    proxy_set_header Connection 'upgrade';
    proxy_set_header Host $host;
    proxy_cache_bypass $http_upgrade;
    try_files $uri $uri/ /index.html;
  }
}
 */
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
